export const GET_CONTACT_AGREEMENTS = 'GET_CONTACT_AGREEMENTS'
export const CONTACT_AGREEMENTS_LOADING = 'CONTACT_AGREEMENTS_LOADING'
